module.exports = __webpack_public_path__ + "img/tutorial-1.b69ebf8c.jpg";